import { render, staticRenderFns } from "./AddContract.vue?vue&type=template&id=979d9d24&scoped=true"
import script from "./AddContract.vue?vue&type=script&lang=js"
export * from "./AddContract.vue?vue&type=script&lang=js"
import style0 from "./AddContract.vue?vue&type=style&index=0&id=979d9d24&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "979d9d24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('979d9d24')) {
      api.createRecord('979d9d24', component.options)
    } else {
      api.reload('979d9d24', component.options)
    }
    module.hot.accept("./AddContract.vue?vue&type=template&id=979d9d24&scoped=true", function () {
      api.rerender('979d9d24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/purchaseService/components/AddContract.vue"
export default component.exports